<template>
    <Layout>
        <div class="about">
            <div class="container">
                <h1 class="title">關於我們</h1>
                
                <div class="content">
                    <div class="company-intro">
                        <h2>公司簡介</h2>
                        <p>
                            KY嚴選是康淵國際有限公司旗下的專業美妝電商平台，致力於為消費者提供優質的美妝產品。我們精心挑選各類保養品、彩妝、香水等多樣化商品，為您打造完美妝容與肌膚保養。
                        </p>
                    </div>

                    <div class="company-info">
                        <h2>公司資訊</h2>
                        <div class="info-grid">
                            <div class="info-item">
                                <h3>公司名稱</h3>
                                <p>康淵國際有限公司</p>
                            </div>
                            <div class="info-item">
                                <h3>統一編號</h3>
                                <p>52378292</p>
                            </div>
                            <div class="info-item">
                                <h3>公司地址</h3>
                                <p>新北市新莊區五權一路1號5樓之3</p>
                            </div>
                        </div>
                    </div>

                    <div class="our-values">
                        <h2>我們的理念</h2>
                        <div class="values-grid">
                            <div class="value-item">
                                <h3>品質保證</h3>
                                <p>嚴選優質美妝產品，確保每一件商品都符合最高品質標準。</p>
                            </div>
                            <div class="value-item">
                                <h3>專業服務</h3>
                                <p>提供專業的美妝諮詢與建議，協助顧客找到最適合的產品。</p>
                            </div>
                            <div class="value-item">
                                <h3>顧客至上</h3>
                                <p>以顧客需求為導向，提供貼心且便捷的購物體驗。</p>
                            </div>
                        </div>
                    </div>

                    <div class="our-products">
                        <h2>商品系列</h2>
                        <div class="products-grid">
                            <div class="product-category">
                                <h3>保養品</h3>
                                <p>提供完整的肌膚保養方案，從清潔到修護，呵護您的每一寸肌膚。</p>
                            </div>
                            <div class="product-category">
                                <h3>彩妝</h3>
                                <p>豐富多樣的彩妝產品，讓您輕鬆打造完美妝容。</p>
                            </div>
                            <div class="product-category">
                                <h3>香水</h3>
                                <p>精選各國知名香水品牌，為您增添獨特魅力。</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import Layout from '@/layouts/Layout.vue'

export default {
    name: 'About',
    components: {
        Layout,
    }
}
</script>

<style scoped>
.about {
    padding: 80px 0;
    background-color: #f9f9f9;
    min-height: 100vh;
}

.container {
    max-width: 1000px;
    margin: 0 auto;
    padding: 0 20px;
}

.title {
    font-size: 2rem;
    color: #333;
    margin-bottom: 2rem;
    text-align: center;
    font-weight: 700;
}

.content {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    padding: 40px;
}

.company-intro,
.company-info,
.our-values,
.our-products {
    margin-bottom: 3rem;
    padding-bottom: 2rem;
    border-bottom: 1px solid #eee;
}

.company-intro:last-child,
.company-info:last-child,
.our-values:last-child,
.our-products:last-child {
    border-bottom: none;
}

h2 {
    font-size: 1.5rem;
    color: #333;
    margin-bottom: 1.5rem;
    font-weight: 600;
}

h3 {
    font-size: 1.2rem;
    color: #444;
    margin-bottom: 1rem;
    font-weight: 600;
}

p {
    font-size: 1rem;
    line-height: 1.6;
    color: #555;
    margin-bottom: 1rem;
}

.info-grid,
.values-grid,
.products-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
    margin-top: 1.5rem;
}

.info-item,
.value-item,
.product-category {
    background-color: #f8f8f8;
    padding: 1.5rem;
    border-radius: 8px;
    transition: transform 0.3s ease;
}

.info-item:hover,
.value-item:hover,
.product-category:hover {
    transform: translateY(-5px);
}

.info-item h3,
.value-item h3,
.product-category h3 {
    color: #F99393;
    margin-bottom: 0.8rem;
}

@media (max-width: 768px) {
    .about {
        padding: 60px 0;
    }
    
    .content {
        padding: 25px;
    }
    
    .title {
        font-size: 1.8rem;
    }
    
    h2 {
        font-size: 1.3rem;
    }
    
    .info-grid,
    .values-grid,
    .products-grid {
        grid-template-columns: 1fr;
        gap: 1.5rem;
    }
}
</style>